import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import NutshellClassic from './icon-nutshell-classic.svg';

function SvgComponent() {
    return <NutshellClassic height={40} width={70} />;
}

export const NutshellClassicIcon = svgIconWrapper(SvgComponent);
